import React from 'react';

const Updating = ({ message = "Le hub est en cours de mise à jour. Veuillez patienter...", dateEnd }) => {

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center animate-fade-in">
        <div className="text-6xl mb-4 animate-bounce">🏗️</div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4 animate-slide-in">
          Mise à jour en cours
        </h1>
        <p className="text-gray-600 mb-4 animate-fade-in-delay">
          {message}
        </p>
        {dateEnd && (
          <p className="text-gray-500 text-sm mb-6">
            Fin estimée : {formatDate(dateEnd)}
          </p>
        )}
        <button
          onClick={() => window.location.reload()}
          className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
        >
          Actualiser
        </button>
      </div>
    </div>
  );
};

export default Updating; 